module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "ra-section newsletter dark"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "subject"
  }, [_vm._v("Get updates")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true,
        newsletterCheckEmail: true,
      }),
      expression: "{\n              required: true,\n              email: true,\n              newsletterCheckEmail: true,\n            }"
    }],
    class: {
      error: _vm.errors.has('email')
    },
    attrs: {
      "id": "ra-email",
      "type": "email",
      "placeholder": "Your email address",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('email')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("email")))]) : _vm._e()]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "ra-newsletter-button",
      "type": "button"
    },
    on: {
      "click": _vm.emailSubmit
    }
  }, [(!_vm.isLoading) ? _c('span', [_vm._v("Subscribe")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('span', [_c('i', {
    staticClass: "far fa-spinner-third fa-spin"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n          Subscribe to the WWF newsletter and stay up-to-date with the latest\n          news on WWF’s work.\n        ")])])])]), _vm._v(" "), (_vm.showModal) ? _c('NewsletterDetails', {
    attrs: {
      "email": _vm.email,
      "showModal": _vm.showModal
    },
    on: {
      "closeModal": _vm.closeModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4414d9ea","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!./~/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./src/components/newsletter/Newsletter.vue
// module id = 679
// module chunks = 0